import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Progress, Image, Divider, notification, Space } from 'antd';
import { useDispatch } from 'react-redux';
import * as TC_SDK from 'trustless-computer-sdk';
import { styled } from 'styled-components';
import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';
import { ENVS, isMainnet } from 'src/configs/Configs.env';
import { getErc20Contract, useContract } from 'src/hooks/useContract';
import useActiveWeb3React from 'src/hooks/useActiveWeb3React';
import contractMint from 'src/contracts/mint.json';
import ImgTopBanner from '../assets/nfts/nft-group.png';
import { ChainId } from 'src/configs/Connect/Configs.chainId';
import { MEDIA_WIDTHS } from '../theme/Theme';
import Countdown, { CountdownRenderProps, zeroPad } from 'react-countdown';

const Wrapper = styled.div`
    width: 100%;
    .mint-btn {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .disable {
            cursor: no-drop;
            background: #00000091 !important;
        }
    }
    .mint-btn-group {
        display: flex;
    }
    .body {
        margin: 0 auto;
        padding: 24px;
        max-width: 1096px;
        background: rgba(234, 52, 176, 0.1);
        border: 1px solid #ea34b0;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        gap: 15px;
        .top-form-title {
            font-family: 'Joystix';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            color: #808080;
        }
        .top-form-title-2 {
            background: #ffffff;
            border-radius: 4px;
            box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
            max-width: 198px;
            height: 52px;
            display: flex;
            align-items: center;
            margin-top: 10px;
            margin-bottom: 25px;
            p {
                padding: 5px;
                font-family: 'Joystix';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 32px;
                display: flex;
                align-items: center;
                text-align: center;
                color: #585858;
            }
        }
        .top-form-title-3 {
            p {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 24px;
                line-height: 36px;
                color: #000000;
                margin-top: 10px;
            }
        }
        .right {
            flex: 1;
            // padding: 30px;
            .large-title {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 32px;
                line-height: 44px;
                color: #000000;
            }
            .small-title {
                font-style: normal;
                font-weight: 400;
                font-size: 20px;
                line-height: 170%;
            }
        }
        .left {
            flex: 1;
            display: flex;
            justify-content: center;
            padding: 5px;
            img {
                border-radius: 8px;
            }
        }

        .content {
            flex: 1;
            width: 100%;
            .box-content {
                width: 100%;
                height: 100%;
                aspect-ratio: 1 / 0.3;
                background: rgba(0, 0, 0, 0.3);
                padding: 12px;
                border-radius: 8px;
                border: 2px solid white;
                margin-bottom: 12px;
                .title {
                    aspect-ratio: 1/0.2;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 26px;
                    text-align: left;
                    display: flex;
                    align-items: center;
                    color: white;
                }
                .desc {
                    height: 100%;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    text-align: left;
                    color: white;
                }
            }
        }
        .content-row {
            width: 508px;
        }
        // .box-form-button{
        //     margin: auto;
        // }
        .box-top {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 32px;
            .box-top-title {
                margin-bottom: 12px;
                color: #fff;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 12px;
                text-align: center;
                letter-spacing: 0.01em;
                text-transform: uppercase;
                margin-top: 20px;
            }
            .box-top-content {
                display: flex;
                flex-direction: row;
                color: #fff;
                span {
                    margin: auto 0;
                }
                .top-content-text {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-size: 40px;
                    line-height: 48px;
                    letter-spacing: -0.01em;
                    padding-bottom: 12px;
                    margin-left: 8px;
                }
            }
        }
        .box-form {
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            .box-form-title {
                margin: 16px 0 16px 0;
                color: #fff;
            }
            .box-form-wrapper {
                display: flex;
                flex-direction: column;
                // margin-bottom: 20px;
                .box-form-input {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    border: 1px solid #6a6c7b;
                    border-radius: 4px;
                    padding: 12px;
                    margin-bottom: 24px;
                    align-items: baseline;
                    margin-top: 24px;
                    max-width: 198px;
                    .box-form-input-title {
                        color: #fff;
                    }
                    .box-form-input-content {
                        display: flex;
                        flex-direction: row;
                        .content-button-circle {
                            height: 28px;
                            width: 28px;
                            border-radius: 50%;
                            font-size: 20px;
                            background: #6a6c7b;
                            cursor: pointer;
                            font-family: 'Joystix';
                        }
                        .content-button-circle-baby {
                            height: 28px;
                            width: 28px;
                            border-radius: 50%;
                            font-size: 20px;
                            background: #6a6c7b;
                            cursor: pointer;
                            font-family: 'Joystix';
                        }
                        .content-data {
                            margin: auto 21px;
                            font-family: 'Joystix';
                        }
                        .content-data-logo {
                            margin: auto 13.5px;
                        }
                        .content-logo-network {
                            width: 28px;
                        }
                    }
                }
                .box-form-allocation {
                    display: flex;
                    flex-direction: column;
                    .box-allocation-top {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-bottom: 12px;
                        color: #fff;
                    }
                    .box-allocation-bottom {
                        margin-bottom: 40px;
                        .progress-bar-allocation {
                            height: 8px;
                            width: 100%;
                            .ant-progress-bg {
                                background: rgb(87, 255, 103);
                            }
                        }
                    }
                }
                .box-form-button {
                    .btn-mint-now {
                        width: auto;
                        padding: 0 40px;
                        height: 54px;
                        color: white;
                        background: black;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        span {
                            font-family: 'Joystix';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 16px;
                            line-height: 20px;
                            text-align: center;
                            color: #ffffff;
                        }
                    }
                }
                .check-inventory {
                    margin: auto;
                    justify-content: center;
                    span {
                        font-family: 'Joystix';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        color: #000000;
                    }
                }
            }
        }
    }
    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        padding: 10px;
        .body {
            display: block;
            .content-row {
                flex-direction: row;
                -webkit-column-count: 1; /* Chrome, Safari, Opera */
                -moz-column-count: 1; /* Firefox */
                column-count: 1;
                width: 100%;
                .small-title {
                    width: 100%;
                }
            }
            .top-form-title-2 {
                width: 100%;
                max-width: 100%;
            }
            .top-form-title-3 {
                margin-bottom: 15px;
                margin-top: 5px;
            }
            .btn-mint-now {
                width: 100% !important;
            }
            .mint-btn-group {
                display: block;
            }
            .left {
                padding: 0px;
            }
            .right {
                padding: 0px;
                margin-top: 25px;
            }
            .large-title {
                font-size: 38px !important;
            }
        }
    }
`;

const CountDownTimer = styled.div`
    margin: 0 auto;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const CountDownBoxNumber = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
`;

const CountDownNumber = styled.span`
    font-family: 'Karmatic Arcade';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
    color: #ea34b0;
`;

const CountDownSubText = styled.span`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #000000;
    margin-top: 8px;
`;

const CountDownColon = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    color: #ea34b0;
    text-align: center;
    padding-top: 12px;
    height: 100%;
`;

const CountDownStart = ({ hrs, mins, secs }: { hrs: number; mins: number; secs: number }) => {
    return (
        <CountDownTimer>
            <CountDownBoxNumber>
                <CountDownNumber>{zeroPad(hrs)}</CountDownNumber>
                <CountDownSubText>hrs</CountDownSubText>
            </CountDownBoxNumber>
            <CountDownColon>:</CountDownColon>
            <CountDownBoxNumber>
                <CountDownNumber>{zeroPad(mins)}</CountDownNumber>
                <CountDownSubText>mins</CountDownSubText>
            </CountDownBoxNumber>
            <CountDownColon>:</CountDownColon>
            <CountDownBoxNumber>
                <CountDownNumber>{zeroPad(secs)}</CountDownNumber>
                <CountDownSubText>secs</CountDownSubText>
            </CountDownBoxNumber>
        </CountDownTimer>
    );
};

const Mint = () => {
    const { chainId, account, library } = useActiveWeb3React();
    const [amount, setAmount] = useState(1);
    const [balanceOf, setBalanceOf] = useState(0);
    const [numberOfMinted, setNumberOfMinted] = useState(0);
    const [loading, setLoading] = useState(false);
    const [canMint, setCanMint] = useState(false);
    const contractABI = contractMint.abi;
    const contractAddr = ENVS.REACT_APP_IS_MAINNET ? contractMint.address.mainnet : contractMint.address.testnet;
    const contract = useContract(contractAddr, contractABI) as any;
    const [loadingApprove, setLoadingApprove] = useState(false);
    const [needApprove, setNeedApprove] = useState(0);

    const renderer = (props: CountdownRenderProps) => {
        const { days, hours, minutes, seconds } = props;
        const hrs = days * 24 + hours;
        return <CountDownStart hrs={hrs} mins={minutes} secs={seconds} />;
    };

    const onClaim = async () => {
        if (!account || !canMint) {
            return;
        }
        try {
            setLoading(true);
            const tx = await contract.mintPunks(amount);
            if (tx) {
                notification.warning({
                    message: 'Waiting!',
                    description: 'Your transaction processing.',
                });
                try {
                    if (tx.hash) {
                        //send TxHash to Wallet TC page sign!
                        const tcWITHDRAWSDKResult = await TC_SDK.signTransaction({
                            method: 'Mint',
                            hash: tx.hash,
                            dappURL: window.location.origin,
                            isRedirect: true,
                            target: '_self',
                            isMainnet: ENVS.REACT_APP_IS_MAINNET,
                        });
                    }
                } catch (error: any) {
                    console.log('[enhanceDeposit][onDepositHandler] ERROR: ', error);
                } finally {
                    setLoading(false);
                }
            }
            checkApprove();
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            let message = error.data?.message === undefined ? error?.message : error.data?.message;
            console.log('message', error);
            notification.error({
                message: 'Ops',
                description: message,
            });
        }
    };

    const contractErc20 = getErc20Contract(
        ENVS.REACT_APP_IS_MAINNET
            ? '0x74b033e56434845e02c9bc4f0cac75438033b00d'
            : '0x2c8f41d3d11db83713038d7666c3a702934174bc',
        library,
        account as any,
    );
    const checkApprove = async () => {
        if (!account || !contractErc20) return;
        try {
            const allowance = await contractErc20.allowance(account, contractAddr);
            const userAlowance = new BigNumber(allowance.toString()).div(10 ** 18).toNumber();
            setNeedApprove(userAlowance);
            const balance = await contract.balanceOf(account);
            setBalanceOf(balance.toNumber());
            const numMinted = await contract.totalSupply();
            setNumberOfMinted(numMinted.toNumber());
        } catch (error: any) {
            console.log('error: ', error);
        }
    };
    const onApprove = async () => {
        if (!account) {
            notification.error({
                message: `Ops`,
                description: 'Please connect wallet to mint.',
            });
            return;
        }
        if (chainId !== ChainId.TC) {
            library?.send('wallet_switchEthereumChain', [{ chainId: '0x56C5' }, account]);
            return false;
        }
        if (!contractErc20 || loadingApprove) return;
        try {
            setLoading(true);
            const approve = await contractErc20.approve(contractAddr, ethers.constants.MaxUint256);
            await approve.wait();
            checkApprove();
            setLoading(false);
        } catch (error: any) {
            const message = error.data?.message === undefined ? error?.message : error.data?.message;
            notification.error({
                message: `Ops`,
                description: message,
            });
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        checkApprove();
    }, [account]);
    useEffect(() => {
        const givenDate = new Date(1685361600000); // Given date in milliseconds

        const interval = setInterval(() => {
            const currentDate = new Date(); // Current date

            if (givenDate < currentDate) {
                console.log('Given date is in the past');
            } else if (givenDate >= currentDate) {
                console.log('Given date is in the future');
                setCanMint(true);
            }
        }, 1000); // Interval duration in milliseconds

        return () => {
            clearInterval(interval); // Clean up the interval on component unmount
        };
    }, []);
    let classButton = 'btn-primary btn-mint-now disable';
    let btnLabel = 'Mint Now';
    if (needApprove === 0) {
        btnLabel = 'Approve WETH';
        classButton = 'btn-primary btn-mint-now';
    }
    if (needApprove && !canMint) {
        classButton = 'btn-primary btn-mint-now disable';
    }
    if (needApprove && canMint) {
        classButton = 'btn-primary btn-mint-now';
    }
    return (
        <Wrapper>
            <div className="body">
                <div className="left">
                    <Image preview={false} src={ImgTopBanner} />
                </div>
                <div className="right">
                    <div className="content">
                        <p className="large-title">Meet your BPunks</p>
                        <div className="content-row">
                            {/* <div className="box-top">
                            <div className="fs-suppersmall fw-bold box-top-title">INO PURCHASE</div>
                            <div className="box-top-content">
                                <span className="fs-medium">STOCK LEFT</span>
                                <span className="fw-bold top-content-text">{stockLeft > 0 ? stockLeft : 0}</span>
                            </div>
                        </div> */}
                            <div className="box-form">
                                <div className="box-form-wrapper">
                                    <Row>
                                        <Col xs={24} md={10}>
                                            <p className="top-form-title">Created by</p>
                                            <div className="top-form-title-2">
                                                <p>BPunks.club</p>
                                            </div>
                                        </Col>
                                        <Col xs={24} md={14}>
                                            <p className="top-form-title">Collection</p>
                                            <div className="top-form-title-2">
                                                <p>BPunks</p>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={24} md={10}>
                                            <p className="top-form-title">Current price</p>
                                            <div className="top-form-title-3">
                                                <p>0.01 WETH</p>
                                            </div>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <p className="top-form-title">Minted</p>
                                            <div className="top-form-title-3">
                                                <p>{numberOfMinted}</p>
                                            </div>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <p className="top-form-title">Totals</p>
                                            <div className="top-form-title-3">
                                                <p>10000</p>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: '12px' }}>
                                        <Col xs={24} md={10}>
                                            <p className="top-form-title">COUNTDOWN START</p>
                                            <Countdown
                                                daysInHours
                                                autoStart
                                                date={new Date(1685361600000).toLocaleString()}
                                                renderer={renderer}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={24} md={10}>
                                            <div className="box-form-input amount-box">
                                                <div className="box-form-input-content">
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (amount === 1) {
                                                                return;
                                                            }
                                                            setAmount(amount - 1);
                                                        }}
                                                        className={`${
                                                            amount === 1
                                                                ? 'content-button-circle'
                                                                : 'content-button-circle-baby'
                                                        }`}
                                                    >
                                                        -
                                                    </button>
                                                    <span className="content-data fs-regular fw-medium">{amount}</span>
                                                    <button
                                                        type="button"
                                                        className="content-button-circle"
                                                        onClick={() => {
                                                            setAmount(amount + 1);
                                                        }}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} md={14} className="mint-btn-group">
                                            <div className="box-form-button mint-btn">
                                                <Button
                                                    className={classButton}
                                                    loading={loading}
                                                    onClick={() => {
                                                        if (needApprove === 0) {
                                                            return onApprove();
                                                        }
                                                        onClaim();
                                                    }}
                                                >
                                                    {btnLabel}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <div className="box-form-input">
                                        <div className="box-form-input-title">
                                            <span className="fs-small">Price per mint</span>
                                        </div>
                                        <div className="box-form-input-content">
                                            <span className="content-data-logo fs-regular fw-medium">{priceBox}</span>

                                            <img src={LogoIconBNB} alt="" className="content-logo-network" />
                                        </div>
                                    </div>
                                    <div className="box-form-input">
                                        <div className="box-form-input-title">
                                            <span className="fs-small">Total</span>
                                        </div>
                                        <div className="box-form-input-content">
                                            <span className="content-data-logo fs-regular fw-medium">
                                                {amount * priceBox}
                                            </span>
                                            <img src={LogoIconBNB} alt="" className="content-logo-network" />
                                        </div>
                                    </div> */}
                                    {/* {timer.timeLeft >= 3000 && (
                                    <Row className="pool-allowcation">
                                        <div className="pool-opening">Opening for INO purchase</div>
                                        <Row className="timer">
                                            <Col>
                                                <span className="fs-avglarge fw-bold">
                                                    {timer.days.toString().padStart(2, '0')}
                                                </span>
                                                <span className="fs-regular fw-medium">Days</span>
                                            </Col>
                                            <Col>
                                                <span className="fs-avglarge fw-bold">
                                                    {timer.hours.toString().padStart(2, '0')}
                                                </span>
                                                <span className="fs-regular fw-medium">Hours</span>
                                            </Col>
                                            <Col>
                                                <span className="fs-avglarge fw-bold">
                                                    {timer.minutes.toString().padStart(2, '0')}
                                                </span>
                                                <span className="fs-regular fw-medium">Mins</span>
                                            </Col>
                                            <Col>
                                                <span className="fs-avglarge fw-bold">
                                                    {timer.seconds.toString().padStart(2, '0')}
                                                </span>
                                                <span className="fs-regular fw-medium">Secs</span>
                                            </Col>
                                        </Row>
                                    </Row>
                                )} */}
                                    {/* <div className="box-form-allocation">
                                    <div className="box-allocation-top">
                                        <span className="fs-regular">Your allocation</span>
                                        <span className="fs-regular">
                                            {maxAllowcation > 0 ? currentAllocation : 0}/{maxAllowcation} NFTs
                                        </span>
                                    </div>
                                    <div className="box-allocation-bottom">
                                        <Progress
                                            className="progress-bar-allocation"
                                            percent={(currentAllocation / maxAllowcation) * 100}
                                            showInfo={false}
                                            status="active"
                                        />
                                    </div>
                                </div> */}

                                    {balanceOf > 0 ? (
                                        <div className="check-inventory">
                                            <span className="fs-regular fw-medium">
                                                You have bought {balanceOf} NFTs
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default Mint;
